import {
  HomeOutlined,
  PlusOutlined,
  SmileOutlined,
  SyncOutlined,
  UserOutlined,
} from "@ant-design/icons"
import {
  Avatar,
  Badge,
  Button,
  Popover,
  Progress,
  Space,
  Spin,
  Tag,
  Tooltip,
  Typography,
} from "antd"
import { useState } from "react"

import userPic from "#/assets/mockAvatars/userPic.jpg"
import ButtonToggleModal from "#blocks/ButtonToggleModal"
import Flex from "#blocks/Flex"
import LinkButton from "#blocks/LinkButton"
import TooltipBlock from "#views/AdminView/ClassScheduleTimeline/TooltipBlock"

import AntdSection from "./AntdSection"

const AntdBasics = () => {
  const [count, setCount] = useState(1)

  return (
    <Flex col gap={20} style={{ paddingBottom: 40 }}>
      <AntdSection title="Icons ">
        <Flex gap={10}>
          <HomeOutlined />
          <SmileOutlined rotate={180} />
          <SyncOutlined spin />
        </Flex>
      </AntdSection>

      <AntdSection title="Buttons">
        <Button type="primary">Primary</Button>
        <Button type="default">Default</Button>
        <Button type="default" loading>
          Loading
        </Button>

        {/* building block */}
        <LinkButton>Link</LinkButton>

        <Button shape="circle" icon={<PlusOutlined />} color="purple" />
        <Button shape="circle" icon={<PlusOutlined />} type="primary" />
      </AntdSection>

      <AntdSection title="Popups">
        <ButtonToggleModal buttonLabel="Open modal" modalTitle="Modal title">
          <div>Modal content</div>
        </ButtonToggleModal>

        <Tooltip
          title={
            <TooltipBlock title="Tooltip">
              Note: requires a ref, so can't attach to custom components without
              forward ref
            </TooltipBlock>
          }
        >
          <div style={{ padding: 4, border: "1px solid #ccc" }}>
            Hover tooltip
          </div>
        </Tooltip>

        <Popover
          content="Similar to tooltip, but can have actions"
          trigger="click"
        >
          <div style={{ padding: 4, border: "1px solid #ccc" }}>
            Click popover
          </div>
        </Popover>
      </AntdSection>

      <AntdSection title="Load spinner">
        <Spin />
      </AntdSection>

      <AntdSection title="Progress bar">
        <Progress percent={50} />
      </AntdSection>

      <AntdSection title="Tag">
        <Tag color="blue">Tag</Tag>
        <Tag color="green">Tag</Tag>
        <Tag color="yellow">Tag</Tag>
        <Tag color="red">Tag</Tag>
        <Tag color="purple">Tag</Tag>
        <Tag color="orange">Tag</Tag>
      </AntdSection>

      <AntdSection title="Avatar with badge">
        <Flex col gap={20}>
          <Space.Compact>
            <Button onClick={() => setCount(count - 1)} size="small">
              -
            </Button>
            <Button onClick={() => setCount(count + 1)} size="small">
              +
            </Button>
          </Space.Compact>
          <Flex gap={20}>
            <Badge count={count} size="small" offset={[0, 0]} overflowCount={9}>
              {/* Icon acts as a fallback */}
              <Avatar size={24} src={userPic} icon={<UserOutlined />} />
            </Badge>
            <Badge
              count={count}
              size="default"
              offset={[0, 0]}
              overflowCount={9}
            >
              <Avatar size={36} shape="square" src={userPic} />
            </Badge>

            <Badge count={count} size="small" offset={[0, 0]} overflowCount={9}>
              <Avatar size={24} icon={<UserOutlined />} />
            </Badge>
            <Badge
              count={count}
              size="default"
              offset={[0, 0]}
              overflowCount={9}
            >
              <Avatar size={36} shape="square" icon={<UserOutlined />} />
            </Badge>
          </Flex>
        </Flex>
      </AntdSection>

      <AntdSection title="Ribbon">
        <Badge.Ribbon text="New" color="blue">
          <Flex col gap={10} style={{ border: "1px solid #ccc", padding: 20 }}>
            <Typography.Title level={5}>Title</Typography.Title>
            <Typography.Text>Some text content</Typography.Text>
          </Flex>
        </Badge.Ribbon>
      </AntdSection>
    </Flex>
  )
}

export default AntdBasics
